import { render, staticRenderFns } from "./SupplierBuyDocDetail.vue?vue&type=template&id=322e21f6&"
import script from "./SupplierBuyDocDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierBuyDocDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports